var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"pill":"","color":"primary","text-color":"white"}},[_c('v-avatar',{staticClass:"primary darken-4",attrs:{"left":""}},[_c('v-icon',[_vm._v("cake")])],1),_vm._v("\n  "+_vm._s(_vm.birthday)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }